<template>
    <div style="background:#fff; margin-left:3px; "> 
        <div style="border-bottom:2px solid #389;display:flex">
            <el-checkbox @change="selEvent(selAll)" true-label="Y" false-label="N" v-model="selAll" style="line-height:30px; margin-right:2px; "><span style="font-size:12px;color:red">全选</span></el-checkbox>
            <div style="font-size:12px;margin-right:4px;margin-left:15px;line-height:30px">字段查询</div>
            <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:5px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper"  size="small" style="width:110px; ">
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值" ref="refqry" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:260px; ">
                <el-button size="small" slot="append" icon="el-icon-search" @click.native="qryTabData" style="color:#409eff"></el-button>
            </el-input> 
            <el-button type="danger" size="mini" icon="iconfont icon-xiashuangjiantou" @click="chkSel" style=" margin-left:30px;">下推选择记录</el-button>  
            
            <el-button type="info" size="mini" icon="iconfont icon-shanchu" @click="btnExit" style=" margin-left:30px;">取消</el-button>
            <el-button type="primary" size="mini" icon="iconfont icon-yiqueren-xianxing" @click="selSure" style=" margin-left:30px;">确定</el-button>
        </div>
        <el-table :data="tmpData.filter(item=>item.ISNEXT=='N')" 
            border                            
            disabled-hover
            style="overflow:auto;margin-top:1px;"
            size="small"
            ref="reftab"
            v-loading="v_loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            header-cell-class-name="clearPadding"
            :header-cell-style="{ 'color':'#389','text-align':'center'}"
            class="custom-table-border"
            :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
            :min-height="400"
            :height="tabHeight" 
            highlight-current-row >
            <el-table-column label="序号" type="index" width="60" fixed>
                <el-table-column label="序号" type="index" width="60" fixed>
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column   v-for="(item ,index) in tabCol.filter(item=>item.thide=='N'||item.key=='SEL' )" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.edcss!=='checkbox'&&item.sortable=='N'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-date-picker v-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                        <el-input type="number" placeholder="数字框" @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-tag  v-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark">已审核</el-tag>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']!=='Y'" size="mini" type="info" effect="dark">未审核</el-tag>  
                        <el-checkbox v-else-if="item.edcss=='checkbox'" true-label="Y" :disabled="item.key!=='SEL'" false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <el-image fit="scale-down" v-else-if="item.key=='IMGPATH'" style="width:100%;height:20px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">
                            <div slot="error"><i class="el-icon-picture-outline"></i></div>
                        </el-image>
                        <span v-else v-text="scope.row[item.key]"></span>
                    </template>
                </el-table-column> 
            </el-table-column>              
        </el-table>
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
        </div> 
        <el-table  :data="nextData" 
            border                            
            size="small"
            ref="refsel"
            :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
            header-cell-class-name="clearPadding"
            :header-cell-style="{ 'color':'#389','text-align':'center'}"
            class="custom-table-border"
            :height="200" 
            highlight-current-row > 
            <el-table-column label="序号" width="60" type="index"></el-table-column>
            <el-table-column v-for="(item ) in tabCol.filter(item=>item.thide=='N'&&item.key!=='SEL'&&item.key!=='RN')" :key="item.key"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.edcss!=='checkbox'&&item.sortable=='N'"
                :min-width="item.width">
                <template  slot-scope="scope" >
                    <el-tag  v-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark">已审核</el-tag>
                    <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']!=='Y'" size="mini" type="info" effect="dark">未审核</el-tag>  
                    <el-checkbox v-else-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                    <el-image v-else-if="item.key=='IMGPATH'" style="width:100%;height:20px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">
                        <div slot="error"><i class="el-icon-picture-outline"></i></div>
                    </el-image>
                    <div v-else  >{{scope.row[item.key]}}</div>
                </template>
            </el-table-column> 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="75">
                <template slot-scope="scope">
                    <el-button size="mini"   type="text" icon="el-icon-close" @click="nextDel(scope.row,scope.$index)">删除</el-button>   
                </template>
            </el-table-column>
        </el-table>
        <!-- 提示框 -->
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
 
</template>
<script>
import {  getBaseData } from '../../api/user' 
 
export default {
    //props:['v_table','tabCol' ],
    props: {
        v_key2:{
            type: String,
            default:'',
        } ,
 
        v_value2:{
            type: String,
            default:'',
        },
        v_table:{
            type: String,
        },
        tabCol:{
            type: Array,
        },
        v_cond:{
            type: String,
            default:'',
        },
        v_random:{
            type: String,
            default:'',
        },
    },
    data () {
        return {
            oper:'like',
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'',// select 绑定值
            txtparam:'', // input 绑定值
            dataCount:0,
            tmpData:[] ,// 
            allData:[] ,//表数据
            disabled:false,
            selAll:'N',
            operArr:[],
            promptWin:false,
            prompt:'',
            rowSize:50,
            v_url:'xuper_auth/getTableRecMany' , //api请求路径      
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            current:1,
            v_sel:'N',
            nextData:[],
            v_row:{},
            v_loading:false,
        }
    },
    created () {
 
    },
    watch: {
        v_table:function(){ //侦测变量值改变时 执行此方法
            this.v_row={}
            this.qryTabData()  
            this.nextData =[]            
        } ,
        v_value2:function(){ //侦测变量值改变时 执行此方法
            this.v_row={}
            this.qryTabData()  
            this.nextData =[]
        } ,
        v_random:function(){ //侦测变量值改变时 执行此方法
            this.v_row={}
            this.qryTabData() 
            this.nextData =[]
        } 
    },
    mounted () {   
        console.log('random:'+this.v_random)
        this.$refs.refqry.focus()
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        this.qryTabData()
    },
    computed: {
        tabHeight() {
          return  window.innerHeight -385
        },
        scrollerHeight: function() {
            return (window.innerHeight - 80) + 'px';
        }, 
    },
    methods: { 
        //字段查询
        inputQry(){
            this.qryTabData()  
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.qryTabData()
        } ,
        nextDel(row,index){
            this.tmpData.push(JSON.parse(JSON.stringify( Object.assign(row,{ISNEXT:'N', SEL:'N'}))))
            this.nextData.splice(index,1)          
        }, 
        //选择记录
        chkSel(){
            this.tmpData.forEach((item,index)=>{
                if (item.SEL=='Y'){    
                    this.tmpData.splice(index,1,Object.assign(item,{ISNEXT:'Y',SEL:'N'}))
                    this.nextData.push(JSON.parse(JSON.stringify(item)))
                    
                }            
            })
            this.dataCount =this.allData.filter(item=>item.ISNEXT=='N').length
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.tmpData = this.allData.slice(_start,_end);
        },
        selSure(){
            if (this.nextData.length>0) {
                this.$emit('child-sure',this.nextData)
            }else{
                this.promptWin=true
                this.prompt='下推记录为空'
            }
        },
        btnExit(){
            this.$emit('child-exit' )
 
        },
        selEvent(val){
            //if (val =='Y') {
                this.tmpData.forEach(item=>{
                    item['SEL']= val
                })
            //}
        },
        //初始化查询页条数
        initPage(){
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tmpData = this.allData          
            }else{
                this.tmpData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //查询表格数据
        qryTabData(){
            this.v_loading =true
            let cond_= this.v_cond 
            if (this.selparam && this.txtparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and upper('+this.selparam+') like upper(\'%' + this.txtparam+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam+')' +this.oper+'upper(\''+this.txtparam+'\')'
                }
                cond_ =cond_+' order by '+this.selparam
            }
            let v_cond ='',v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid', p_value:this.v_corpid,p_key2:this.v_key2,p_value2:this.v_value2,p_cond:cond_+v_cond,p_table: this.v_table},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result 
                    this.initPage() 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs['reftab'].doLayout()
                        this.v_loading=false
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }    
            }) 
            
        },
 
    }
}
 
</script>
<style scoped lang="less" >
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
 
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
 
</style>
